import { FC, Fragment } from 'react'

import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { Tooltip } from 'ui/components/Tooltip'
import { DocumentItemAlerts } from '~bank-documents/types/DocumentItemAlerts'

import * as SC from './styles'

type AlertsTooltip = {
  id: number
  alerts: DocumentItemAlerts
}

export const AlertsTooltip: FC<AlertsTooltip> = ({ id, alerts }) => (
  <SC.DueRow>
    {alerts.map((alert) => {
      const { type, label, count } = alert

      return (
        <Fragment key={type}>
          {type === 'warning' && (
            <SC.DueCount>
              <Tooltip
                id={`firstHint${id}`}
                type="warning"
                event="hover"
                content={
                  <>
                    {label?.map((label) => (
                      <Fragment key={label}>
                        {label}
                        <br />
                      </Fragment>
                    ))}
                  </>
                }
              >
                <SC.TooltipContent>
                  <Icon name={IconName.EXCLAMATION_ORANGE} size={IconSize.S} /> {count}
                </SC.TooltipContent>
              </Tooltip>
            </SC.DueCount>
          )}
          {type === 'error' && (
            <SC.DueCount>
              <Tooltip
                id={`pastDue${id}`}
                type="error"
                event="hover"
                content={
                  <>
                    {label?.map((label) => (
                      <Fragment key={label}>
                        {label}
                        <br />
                      </Fragment>
                    ))}
                  </>
                }
              >
                <SC.TooltipContent>
                  <Icon name={IconName.EXCLAMATION} size={IconSize.S} /> {count}
                </SC.TooltipContent>
              </Tooltip>
            </SC.DueCount>
          )}
          {type === 'ok' && (
            <SC.DueCount>
              <Icon name={IconName.CHECK_GREEN} size={IconSize.S} />
            </SC.DueCount>
          )}
        </Fragment>
      )
    })}
  </SC.DueRow>
)
